export type SyncStatus = 'idle' | 'queued' | 'running' | 'succeeded' | 'failed';

export interface SyncState {
  status: SyncStatus;
  queuedAt: string | null;
  startedAt: string | null;
  lastSyncAt: string | null;
  lastError: string | null;
}

export const ACTIVE_SYNC_STATUSES: ReadonlySet<SyncStatus> = new Set([
  'queued',
  'running',
]);

export const DEFAULT_SYNC_STATE: SyncState = Object.freeze({
  status: 'idle',
  queuedAt: null,
  startedAt: null,
  lastSyncAt: null,
  lastError: null,
});

export function isSyncActive(status: SyncStatus): boolean {
  return ACTIVE_SYNC_STATUSES.has(status);
}

export function healthStatusFromSyncStatus(
  status: SyncStatus,
): 'idle' | 'syncing' | 'error' {
  if (status === 'failed') {
    return 'error';
  }
  if (isSyncActive(status)) {
    return 'syncing';
  }
  return 'idle';
}
